import OffersLabel from './OffersLabel';

export default OffersLabel;
